export const validEmailRegex = new RegExp('^.*[^.@]@[^@]*[^.@]\\.[^.@].*$', 'i');
